import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild,  QueryList, ViewChildren } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnFilter } from 'src/app/domainObjects/columnFilter';
import { DataConnectorMapping } from 'src/app/domainObjects/dataConnectorMapping';
import { DataTransformerConfig } from 'src/app/domainObjects/dataTransformConfig';
import { ConfigService } from 'src/app/services/config/config.service';
import { ConfigViewModelService } from 'src/app/services/configViewModel/config-view-model.service';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { DataFarmViewModel } from 'src/app/viewModels/dataFarmViewModel';
import { ImportDataViewModel } from 'src/app/viewModels/importDataViewModel';
import { ColumnFilterInfo } from 'src/app/views/previewTable/filterUI/column-filter/column-filter.component';
import { PreviewTableComponent, ColumnInfo } from '../../../preview-table/preview-table.component';
import { BaseTransformerUIComponent } from 'src/app/views/dataTransformConfig/transformers/base/base-transformer-ui/base-transformer-ui.component';
import { TransformPipelineService } from '../../../../services/transformPipeline/transform-pipeline.service';
import { DataDictionaryService } from 'src/app/services/dataDictionary/data-dictionary.service';
import { FormBuilder, FormGroup, UntypedFormControl } from '@angular/forms';
import { ColoredTextItem, NamedColorList } from 'src/app/domainObjects/coloredTextItem';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { UserDataService } from 'src/app/services/user-data-service';
import { RefineryPresenceService } from 'src/app/services/refinery-presence.service';
import { ComponentCanDeactivate } from 'src/app/guards/pending-changes.guard';
import { CacheKeyType, PreviewType, TransformType, TransformTypeUtil } from 'src/app/domainObjects/transformType';
import { ParameterSetting } from 'src/app/domainObjects/masterConfig';
import { JoinerListRequest, JoinerListResponse, JoinerSummaryViewModel, JoinerViewModel } from './joinerViewModel';
import { JoinerRuleViewModel } from './joinerRuleViewModel';
import { DuplicatesKeep, DuplicatesKeepUtil, JoinerMapper, JoinerTransformMapper, MergeOption } from 'src/app/domainObjects/transformers/joinerTransform';
import { JoinerMapperViewModel } from './JoinerMapperViewModel';
import { PreviewDataOptions } from 'src/app/domainObjects/previewDataOptions';
import { GetCacheKeyRequest, GetDataFarmPreviewRequest } from 'src/app/messaging/getDataFarmPreviewRequest';
import { GetSummaryDataFarmPreviewRequest, SummaryType } from 'src/app/messaging/getSummaryDataFarmPreviewRequest';
import { SortInfo } from 'src/app/domainObjects/sortInfo';
import { MatMenuTrigger } from '@angular/material/menu';
import { OptionItem, OptionItemDataType } from 'src/app/model/optionItem';
import { ExportOutputDataDynamicComponent } from '../../export-output-data-dynamic/export-output-data-dynamic.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { InputPrvwFilterViewModel } from 'src/app/viewModels/inputPrvwFilterViewModel';
import { DuplicateKeep, DuplicateKeepUtil, DuplicateType, DuplicateTypeUtil } from '../column-cleaner-transform-detail/columnCleanerRuleViewModel';
import { JoinerMergedOptionViewModel } from './JoinerMergedOptionViewModel';
import { SelectFilterInfo } from 'src/app/views/shared/select-filter-option/select-filter-option.component';
import { SaveCurrntTransfrmcacheRequest } from 'src/app/messaging/saveCurrntTransfrmcacheRequest';
import { DataFarmTypeUtil } from 'src/app/domainObjects/dataFarmType';
import { GetFilteredselcolvalsRequest } from 'src/app/messaging/getFilteredselcolvalsRequest';

@Component({
    selector: 'app-joiner-transform-detail',
    templateUrl: './joiner-transform-detail.component.html',
    styleUrls: ['./joiner-transform-detail.component.css'],
    standalone: false
})
export class JoinerTransformDetailComponent extends BaseTransformerUIComponent<JoinerViewModel> implements OnInit,ComponentCanDeactivate {
  dataSource: MatTableDataSource<JoinerRuleViewModel> | undefined;  
  dataSourceSummary: MatTableDataSource<JoinerSummaryViewModel> | undefined;
  dataSourceFieldMapper: MatTableDataSource<JoinerMapperViewModel> | undefined;
  dataSourceFieldMergeOption: MatTableDataSource<MergeOption> | undefined;

  DuplicatesKeep = DuplicatesKeep;
  DuplicatesKeepUtil = DuplicatesKeepUtil;
  DuplicatesKeeps = [
    DuplicatesKeep.first,
    DuplicatesKeep.last,
    DuplicatesKeep.noRows
  ];
  DuplicateType=DuplicateType;
  DuplicateTypeUtil = DuplicateTypeUtil;
  DuplicateTypes = [
    DuplicateType.exclude,
    DuplicateType.include,
  ];

  DuplicateKeep=DuplicateKeep;
  DuplicateKeepUtil = DuplicateKeepUtil;
  DuplicateKeeps = [
    DuplicateKeep.first,
    DuplicateKeep.last,
    DuplicateKeep.noRows,
  ];
  displayedColumns: string[] = [
    'actions',
    'index',
    'fieldList',
    'duplicatesKeep',
    'isEnabled'];
  displayedColumnsSummary:string[]=[
    'node',
    'name',
    'fields',
    'mapped',
    'rows',
    'merge',
    'field'
  ]
  groupHeaderColumns:string[]=['groupNodes','groupMerge']
  combinedDataSource: MatTableDataSource<{summary: JoinerSummaryViewModel, merge: any}>;
  private buildCombinedDataSource(): void {
    const rows = this.joinersummary.map((summary, i) => ({
      summary,
      merge: this.viewModel.mergeOption[i]
    }));
    this.combinedDataSource = new MatTableDataSource(rows);
  }

  displayedColumnsMergeOption:string[]=[
    'state',
    'field'
  ]
  displayedColumnsFieldMapper:string[]=[
    'field',
    'mapTo'
  ]
  isRuleSetEmpty = true;
  isRuleExecuting = false;

  updateDataSource: any;

  previewDataViewModel = new ImportDataViewModel();
  inputPrvwFilterViewModel = new InputPrvwFilterViewModel();

  isRulesMaximized = false;

  selectedTabIndx = 0;

  sortCtrl = new UntypedFormControl('');
  form: FormGroup;
  
  previewTableLabelA:string="Node A";
  previewTableLabelB:string="Node B";
  previewTableLabelC:string="Node C";
  previewTableLabelD:string="Node D";
  previewTableLabelE:string="Node E";
  previewTableLabelColorA:string="";
  previewTableLabelColorB:string="";
  previewTableLabelColorC:string="";
  previewTableLabelColorD:string="";
  previewTableLabelColorE:string="";
  previewSummaryTableLabelA:string="(A)";
  previewSummaryTableLabelB:string="(B)";
  previewSummaryTableLabelC:string="(C)";
  previewSummaryTableLabelD:string="(D)";
  previewSummaryTableLabelE:string="(E)";
  @ViewChild(ExportOutputDataDynamicComponent) exportComponent: ExportOutputDataDynamicComponent;
  @ViewChildren('joinerNodePreviewTable') joinerNodePreviewTables: QueryList<PreviewTableComponent>;
  @ViewChildren('joinerSummaryTable') joinerSummaryPreviewTables: QueryList<PreviewTableComponent>;

  defaultPlaceholder = 'Select Map to';
  options: string[] =[];

  joinerPreviewTabs: { label: string; color: string; typeName: string }[] = [];
  joinerSummaryRows: string[] = [];
  joinerSelectValues: string[][] = [];
  joinerSelectEmptyColumns: any[][] = [];
  joinerSelectFilterValues: string[][] = [];
  activeJoinerSummaryIndex = -1;

  private readonly joinerInputPreviewTypes = [
    PreviewType.joinerInputA, PreviewType.joinerInputB, PreviewType.joinerInputC,
    PreviewType.joinerInputD, PreviewType.joinerInputE, PreviewType.joinerInputF,
    PreviewType.joinerInputG, PreviewType.joinerInputH, PreviewType.joinerInputI,
    PreviewType.joinerInputJ,
  ];

  constructor(
    activeRoute: ActivatedRoute,
    errorService: ErrorReportingService,
    matDialog: MatDialog,
    snackBar: MatSnackBar,
    router: Router,
    configViewModelService: ConfigViewModelService,
    configService: ConfigService,
    navService: NavigationService,
    transformPipelineService: TransformPipelineService,
    userData: UserDataService,
    dataDictService: DataDictionaryService,
    refineryPresence: RefineryPresenceService,
    private cdRef: ChangeDetectorRef,private fb: FormBuilder) {

    super(activeRoute, errorService, matDialog, snackBar, router, configViewModelService, configService, navService, transformPipelineService, userData,dataDictService, refineryPresence);
  }
  //other parameters

  //advanced settings parameters
  resetRows: ParameterSetting=new ParameterSetting();
  runDedup: ParameterSetting=new ParameterSetting();
  mergeOption: ParameterSetting=new ParameterSetting();

  joinerlists:JoinerListResponse[];
  joinersummary: JoinerSummaryViewModel[] = [];
  transformType:TransformType;
  async ngOnInit(): Promise<void> {
    this.transformType=TransformType.farmJoiner;
    super.ngOnInit();

    this.userData.setInputTabClicked(false);
    this.userData.setResultsTabClicked(false);
    
    this.resetInputPrvwViewModel();
    //validation
    this.isParameterFormValid = true;
    this.form = this.fb.group({
      // searchWildCard: ['', [Validators.required]],
    });
    this.registerFormGroup(this.form);

  }

  protected override async onRouteActivated(_routeParams: any): Promise<void> {
    const busyIndicator = this.showBusyDialog('Loading and Configure data...');
    this.viewModel = new JoinerViewModel(
        this.dataDictService,
        this.configService,
        this.dataTransformConfigViewModel,
        this.transformViewModel);
      //set farm type as state transformViewModel has value 0 bug in parent or prev page
      this.viewModel.farmType=this.userData.getSelectedNodeDetails().farmtypeid;
      //Fetch targetColumns data dict by node farmtypeid  
      this.configureTargetColumnsFarmtypeid(this.userData.getSelectedNodeDetails().farmtypeid);
      //deep copy of viewmodel for canDeactivate
      this.snapshotPreState();

      //for rules default
      // if(this.viewModel.rules.length==0){
      //   const rule = new JoinerTransformRule();
      //   rule.index=1;
      //   rule.fieldList=["All Fields"];
      //   rule.duplicatesKeep=DuplicatesKeep.first
      //   rule.run=true;
      //   const vm = new JoinerRuleViewModel(rule);

      //   this.viewModel.rules.push(vm);
      // }
      //this.dataSource = new MatTableDataSource<JoinerRuleViewModel>(this.viewModel.rules);
      //this.isRuleSetEmpty = this.viewModel.rules.length === 0;
      
      if (this.previewTable) {
        this.previewTable.clear();
      }

      if (this.outputDataFarmPreviewTable) {
        this.outputDataFarmPreviewTable.clear();
      }
      await this.setTransformerDetails(this.transformType);
      await this.setDefaultValues(this.transformType);
      await this.removeInvalidValues();
      
      //get summary and field mapper
      var request=new JoinerListRequest();
      request.userId=this.userData.getUserId();
      request.orgId=this.userData.getOrgId();
      request.refineryId=this.userData.getRefineryId();
      request.nodeId=this.userData.getNodeId();
      request.cacheKeyType=CacheKeyType.node;

      this.joinerlists= await this.configService.getJoinerList(request);
      var premap=[...this.viewModel.fieldMap || []];
      this.viewModel.fieldMap=[];
      var mapper: JoinerTransformMapper;
      var premergeOption=[...this.viewModel.mergeOption];
      this.viewModel.mergeOption=[];
      this.joinerlists.forEach(map=>{
        mapper=new JoinerTransformMapper();
        mapper.nodeID=map.nodeID;
        mapper.index = map.index;
        mapper.indexName = map.indexName;
        mapper.nodeColor = map.nodeColor;
        mapper.nodeFields = map.nodeFields;
        mapper.nodeName = map.nodeName;
        mapper.nodeNo = map.nodeNo;
        mapper.nodeRows = map.nodeRows;
        mapper.mapTable=map.mapTable;
        //check in targetColumns
        mapper.mapTable.forEach(map=>{
          const checktc=this.viewModel.targetColumns.find(tc=>tc===map.mapTo);
          if(checktc){
            map.mapTo=map.mapTo;
          }else{
            map.mapTo="Not Mapped";//undefined;
          }
        })
        
        this.viewModel.fieldMap.push(new JoinerMapperViewModel(mapper));
        //
        var summary=new JoinerSummaryViewModel();
        summary.nodeID=map.nodeID;
        summary.node=map.indexName;
        summary.name=map.nodeNo+": "+map.nodeName;
        summary.fields=map.nodeFields;
        summary.mapped="0";
        summary.rows=map.nodeRows;
        summary.nodeColor=map.nodeColor
        this.joinersummary.push(summary);

        var mergeOption=new MergeOption();
        mergeOption.state=false;
        mergeOption.field="";
        mergeOption.nodeColor=map.nodeColor;
        //this.viewModel.mergeOption.push(mergeOption);
         this.viewModel.mergeOption.push(new JoinerMergedOptionViewModel(mergeOption));
      });
      this.viewModel.fieldMap.forEach(map=>{
        var saveparent=premap.find(x=>x.index==map.index && x.nodeName==map.nodeName);
        if(saveparent){
          map.mapTable.forEach(m=>{
            var savevalue=saveparent.mapTable.find(c=>c.field==m.field);
            if(savevalue){
              const checktc=this.viewModel.targetColumns.find(tc=>tc===savevalue.mapTo);
              if(checktc){
                m.mapTo=savevalue.mapTo;
              }else{
                m.mapTo="Not Mapped";//undefined;
              }
            }
            else{
              m.mapTo="Not Mapped";//undefined;
            }
          })
        }
      });
      
      let i=0;
      this.viewModel.mergeOption.forEach(merge=>{
        var premerge=premergeOption[i];
        if(premerge){
          merge.state=premerge.state;
          merge.field=premerge.field;
        }
        i++;
      });
      // this.joinerlists.forEach(joinerlist => {
      //   var summary=new JoinerSummaryViewModel();
      //   summary.nodeID=joinerlist.nodeID;
      //   summary.node=joinerlist.indexName;
      //   summary.name=joinerlist.nodeNo+": "+joinerlist.nodeName;
      //   summary.fields=joinerlist.nodeFields;
      //   summary.mapped="0";
      //   summary.rows=joinerlist.nodeRows;
      //   summary.nodeColor=joinerlist.nodeColor
      //   this.joinersummary.push(summary);
      // });
      this.dataSourceSummary = new MatTableDataSource<JoinerSummaryViewModel>(this.joinersummary);
      this.dataSourceFieldMergeOption = new MatTableDataSource<MergeOption>(this.viewModel.mergeOption);
      this.buildCombinedDataSource();

      //this.dataSourceFieldMapper = new MatTableDataSource<JoinerMapperViewModel>(this.viewModel.fieldMap);
      this.CalculateFieldsMapped();
      if(!this.viewModel.fieldList){
        this.viewModel.fieldList=[];
        
        this.viewModel.duplicatesType=DuplicateType.exclude;
        this.viewModel.duplicatesKeep=DuplicateKeep.first;

        var options: string[] = [];
        this.viewModel.fieldMap.forEach(map=>{
          var maptos=map.mapTable.map(item => item.mapTo);
          maptos.forEach(map=>{
            options.push(map);
          })
        });
        // Get unique values
        var options = Array.from(new Set(options)).sort();
        for(let pr of this.mergeOption.default.split(";")){
          const foundColumn = options.find(sc => sc == pr);
          if(foundColumn){
            this.viewModel.mergeOption.forEach(fld=>{
              fld.field=foundColumn;
            });
            break;
          }
        }
        //DT-2591
        this.viewModel.fieldList.push(new ColoredTextItem("None",NamedColorList[0]));
        // if(options.find(op=>op=="row")){
        //   this.viewModel.fieldList.push(new ColoredTextItem("row",NamedColorList[0]));
        // }else{
        //   this.viewModel.fieldList.push(new ColoredTextItem("None",NamedColorList[0]));
        // }
      }
      this.joinerPreviewTabs = this.joinerlists
      .slice().sort((a, b) => a.index - b.index)
      .map(map => ({
        label: `Node ${map.indexName} (${map.nodePreviewData.data.columns.length})`,
        color: map.nodeColor,
        typeName: `Node ${map.indexName}`,
      }));
      this.joinerSummaryRows = this.joinerPreviewTabs.map(() => '');
      this.joinerSelectValues = this.joinerPreviewTabs.map(() => []);
      this.joinerSelectEmptyColumns = this.joinerPreviewTabs.map(() => []);
      this.joinerSelectFilterValues = this.joinerPreviewTabs.map(() => []);
      this.cdRef.detectChanges();
      this.joinerNodePreviewTables?.forEach(table => table.onRefreshClicked());
      busyIndicator.close();
      this.joinerSummaryPreviewTables?.forEach(table => this.LoadSummaryPersistance(table));
      //this.removeInvalidSortFields();
      this.getCacheStatus();
      this.options=['Not Mapped', ...this.viewModel.targetColumns.map(col => col).sort((a, b) => a.localeCompare(b))];
  }
  
  ngAfterViewInit(): void {
    
  }
  onTransformTextChanged(){
    this.viewModel.transformViewModel.name=this.viewModel.transform.name;
    var currenttransform=this.dataTransformConfigViewModel.transforms.find(x=>x.guid==this.viewModel.transform.guid);
    currenttransform.name=this.viewModel.transform.name;
    currenttransform.transform.name=this.viewModel.transform.name;
    var vartransform=this.transformslists.find(x=>x.guid==this.viewModel.transform.guid);
    vartransform.name=this.viewModel.transform.name;
  }
  // dropTable(event: CdkDragDrop<MatTableDataSource<JoinerRuleViewModel>>): void {
  //   const prevIndex = event.previousIndex;
  //   const currentItem: JoinerRuleViewModel = event.item.data;
  //   currentItem.index = prevIndex;
  //   moveItemInArray(this.viewModel.rules, prevIndex, event.currentIndex);
  //   this.viewModel.reindexRules();
  //   this.dataSource.data = this.viewModel.rules;
  // }

  // onRunChanged(event: MatSlideToggleChange): void {
  //   this.viewModel.rules.forEach( r => r.run = event.checked);
  // }

  toggleRulesHeight(): void {
    this.isRulesMaximized = !this.isRulesMaximized;
  }

  compareDataFarm(o1: DataFarmViewModel, o2: DataFarmViewModel): boolean {
    return o1.name === o2.name && o1.id === o2.id;
  }
  
  // onDeleteRule(rule: JoinerRuleViewModel): void {
  //   this.showConfirmDialog('Delete Confirmation', `Are you sure you want to delete this rule?`, (confirmed) => {
  //     if (confirmed) {
  //       const index = this.viewModel.rules.indexOf(rule);
  //       this.viewModel.rules.splice(index, 1);
  //       this.viewModel.reindexRules();
        
  //       if ( this.viewModel.rules.length > 0 ) {
  //         const lastIndex = this.viewModel.rules.length - 1;
  //         //this.viewModel.selectedIngestConfig = this.viewModel.importDataViewModel.ingestConfigs[lastIndex];
  //       }
  //       else {
  //         //this.viewModel.selectedIngestConfig = null;
  //       }
  //       this.dataSource.data = this.viewModel.rules;
  //       this.isRuleSetEmpty = this.viewModel.rules.length === 0;
  //       //update rule table height
  //       if(this.viewModel.rules.length<=10){
  //         this.minrowcount=this.viewModel.rules.length;
  //       }else{
  //         this.minrowcount=10;
  //       }
  //       this.maxrowcount=this.viewModel.rules.length;
  //     }
  //   });
  // }

  // onDuplicateRule(sourceRule: JoinerRuleViewModel): void {
    
  //   const vm = new JoinerRuleViewModel(new JoinerTransformRule());
  //   Object.assign(vm, sourceRule);
    
  //   this.viewModel.rules.splice(sourceRule.index, 0, vm);
  //   this.viewModel.reindexRules();
  //   this.dataSource.data = this.viewModel.rules;

  //   //console.log(`rule inserted at index: ${sourceRule.index}`);
  //   //update rule table height
  //   if(this.viewModel.rules.length<=10){
  //     this.minrowcount=this.viewModel.rules.length;
  //   }else{
  //     this.minrowcount=10;
  //   }
  //   this.maxrowcount=this.viewModel.rules.length;
  // }
  minrowcount:number=10;
  maxrowcount:number=100;
  isScrollBottom:boolean=true;
  // addNewRule(): void {
  //   var isValidDefaultParam=true;
  //   const selectedNode=this.userData.getSelectedNodeDetails();
  //   const masterconfig=this.userData.getMasterTransformers().find(x=>x.id==TransformType.farmJoiner);
  //   var params=masterconfig.parameters.find(x=>x.farmtypeid==selectedNode.farmtypeid).parameters.filter(n=>n.isruledefault==true);
  //   params.forEach(field => {
  //     if(field.jsonobject=="defSourceField"){
  //       if(!this.viewModel.parameters.sourceColumn){
  //         isValidDefaultParam=false;
  //       }
  //     }
  //     else if(field.jsonobject=="defTargetField"){
  //       if(!this.viewModel.parameters.targetColumn){
  //         isValidDefaultParam=false;
  //       }
  //     }
  //     else if(field.jsonobject=="userIdField"){
  //       if(!this.viewModel.parameters.userColumn){
  //         isValidDefaultParam=false;
  //       }
  //     }
  //     else if(field.jsonobject=="timestampField"){
  //       if(!this.viewModel.parameters.timeColumn){
  //         isValidDefaultParam=false;
  //       }
  //     }
  //   });

  //   if (!isValidDefaultParam) {
  //     this.displayError("Cannot add Rule unless Default field(s) are entered.","Please fix the validation error.");
  //     return;
  //   }
  //   const id = this.viewModel.rules.length;
  //   const rule = new JoinerTransformRule();
  //   rule.index = id+1;
  //   rule.duplicatesKeep =DuplicatesKeep.first;
  //   const vm = new JoinerRuleViewModel(rule);

  //   this.viewModel.rules.push(vm);
  //   this.isRuleSetEmpty = this.viewModel.rules.length === 0;
  //   this.dataSource.data = this.viewModel.rules;

  //   //update rule table height
  //   if(this.viewModel.rules.length<=10){
  //     this.minrowcount=this.viewModel.rules.length;
  //   }else{
  //     this.minrowcount=10;
  //   }
  //   this.maxrowcount=this.viewModel.rules.length;
  // }
  async refreshPreviewTableJoiner(sender: PreviewTableComponent): Promise<void> {
    if (this.joinerNodePreviewTables?.toArray().includes(sender)) {
      await this.refreshJoinerDataFarmPreviewAsync(sender);
    } else if (this.joinerSummaryPreviewTables?.toArray().includes(sender)) {
      await this.refreshSummaryDataFarmPreviewAsync(sender);
    } else {
      this.refreshPreviewTable(sender);
    }
  }
  async onRefreshClicked(sender: PreviewTableComponent): Promise<void> {
    await this.refreshPreviewTableJoiner(sender);
  }
  async refreshJoinerDataFarmPreviewAsync(sender: PreviewTableComponent): Promise<void> {
    const index = this.joinerNodePreviewTables.toArray().indexOf(sender);
    if (index < 0) return;
    const cachekeyRequest = await this.GetCacheKeyRequest(this.joinerInputPreviewTypes[index]);
    const selectedJoinerPreviewSummaryTable = this.joinerSummaryPreviewTables?.toArray()[index] ?? null;
    sender.isGettingData.next(true);
    try {
      const filters = sender.activeFilterSet?.map(f => {
        const filterInfo = new ColumnFilter();
        filterInfo.field = f.columnName;
        filterInfo.values = f.values;
        return filterInfo;
      });
      const options = new PreviewDataOptions(sender.pageIndex, sender.rowsPerPage,this.activeSortsSet,filters);
      var request :GetDataFarmPreviewRequest = null;
      request = new GetDataFarmPreviewRequest(
        cachekeyRequest.userId,
        cachekeyRequest.orgId,
        cachekeyRequest.refineryId,
        cachekeyRequest.nodeId,
        cachekeyRequest.transformId,
        cachekeyRequest.cacheKeyType,
        options);
      
      const response = await this.configService.getInputDataForNode(request);
      sender.bindData(response.data, 'No input preview data');
      this.LoadSummaryPersistance(selectedJoinerPreviewSummaryTable, true);
      //this.lookupcolumncount=response.data.columns.length;
    } catch (err) {
      this.displayError('Failed to get data farm preview', 'Error', err);
    } finally {
      sender.isGettingData.next(false);
    }
  }
  async onClearFilter(sender: PreviewTableComponent, activeFilterSet: ColumnFilterInfo[], columnName: string): Promise<void> {
    const summaryTables = this.joinerSummaryPreviewTables?.toArray() ?? [];
    const index = summaryTables.indexOf(sender);
    if (index >= 0 && index < this.joinerPreviewTabs.length) {
      const busyIndicator = this.showBusyDialog('Please wait...');
      const tab = this.joinerPreviewTabs[index];
      this.userData.setSummaryFilter(await this.GetLocalStorageKey(tab.typeName), []);
      await this.refreshSummaryDataFarmPreviewAsync(sender);
      busyIndicator.close();
    } else {
      const busyIndicator = this.showBusyDialog('Please wait...');
      await this.refreshPreviewTableJoiner(sender);
      busyIndicator.close();
    }
  }

  override async onApplyFilter(sender: PreviewTableComponent, activeFilterSet: ColumnFilterInfo[], info: ColumnFilterInfo): Promise<void> {
    const summaryTables = this.joinerSummaryPreviewTables?.toArray() ?? [];
    const summaryIndex = summaryTables.indexOf(sender);
    if (summaryIndex >= 0 && summaryIndex < this.joinerPreviewTabs.length) {
      const busyIndicator = this.showBusyDialog('Please wait...');
      const tab = this.joinerPreviewTabs[summaryIndex];
      this.userData.setSummaryFilter(await this.GetLocalStorageKey(tab.typeName), sender.activeFilterSet);
      await this.refreshSummaryDataFarmPreviewAsync(sender);
      busyIndicator.close();
    } else if (this.joinerNodePreviewTables?.toArray().includes(sender)) {
      const busyIndicator = this.showBusyDialog('Please wait...');
      await this.refreshPreviewTableJoiner(sender);
      busyIndicator.close();
    } else {
      await super.onApplyFilter(sender, activeFilterSet, info);
    }
  }

  override async onApplySort(sender: PreviewTableComponent, sortData: SortInfo[]): Promise<void> {
    const summaryTables = this.joinerSummaryPreviewTables?.toArray() ?? [];
    const index = summaryTables.indexOf(sender);
    if (index >= 0 && index < this.joinerPreviewTabs.length) {
      const tab = this.joinerPreviewTabs[index];
      this.userData.setSummarySort(await this.GetLocalStorageKey(tab.typeName), sender.activeSortsSet);
      await this.refreshSummaryDataFarmPreviewAsync(sender);
    } else {
      await super.onApplySort(sender, sortData);
    }
  }

  async onPageChanged(sender: PreviewTableComponent,totalRows: number,pageSize: number,pageIndex: number): Promise<number> {
      const busyIndicator = this.showBusyDialog('Please wait...');
      await this.refreshPreviewTableJoiner(sender);
      busyIndicator.close();
      return totalRows;
  }

  getClassForRow(sender: PreviewTableComponent, row: any, colInfo: ColumnInfo, colInfos: ColumnInfo[]): string {
  
    try {
      return this.getClassForRowBase(sender, row, colInfo, colInfos)
    } catch (err) {
      //console.log(err);
      return null;
    }
  }
  onColoredTextCellClickedDuplicate(fieldList: ColoredTextItem[]): void {
    let title: string=`Field Chooser`;
    let label: string="Field Name";
    let placeholder: string="Enter Value";
    let fieldType: string ="autocomplete";
    let isDuplicateRemoved: boolean =true;
    let canAddNewAutocomplete: boolean =false;
    var options: string[] = [];
    let dialogWidth: string='600px'
      
      if(this.viewModel.duplicatesType==DuplicateType.exclude){
        options.push("None");
      }else{
        options.push("All");
      }
      
      this.viewModel.fieldMap.forEach(map=>{
        var maptos=map.mapTable.filter(mp=>mp.mapTo!="Not Mapped").map(item => item.mapTo);
        maptos.forEach(map=>{
          options.push(map);
        })
      });
      // Get unique values
      var options = Array.from(new Set(options)).sort();

      if(!fieldList){
        fieldList=[];
      }
  
      this.showTextEditorDialogOption(title, label,placeholder,fieldType,isDuplicateRemoved,canAddNewAutocomplete,options,dialogWidth, 
          fieldList,
          async (items: ColoredTextItem[],eventname:string) => {
          if(eventname=='save'){
            if(items.length===0){
              this.viewModel.fieldList=[];
              if(this.viewModel.duplicatesType===DuplicateType.exclude){
                this.viewModel.fieldList.push(new ColoredTextItem("None",NamedColorList[0]));
              }else if(this.viewModel.duplicatesType===DuplicateType.include){
                this.viewModel.fieldList.push(new ColoredTextItem("All",NamedColorList[0]));
              }
            }else{
                this.viewModel.fieldList = items;
            }
          }
        });
    }

  onColoredTextCellClicked(fieldName: string, rule: JoinerRuleViewModel): void {
    if(rule.index!=1){
      let title: string=`Field Chooser Rule ${rule.index}`;
      let label: string="Field Name";
      let placeholder: string="Enter Value";
      let fieldType: string ="dropdown";
      let isDuplicateRemoved: boolean =true;
      let canAddNewAutocomplete: boolean =false;
      var options: string[] = [];
      let dialogWidth: string='600px'

      this.viewModel.fieldMap.forEach(map=>{
        var maptos=map.mapTable.map(item => item.mapTo);
        maptos.forEach(map=>{
          options.push(map);
        })
      });
      // Get unique values
      var options = Array.from(new Set(options)).sort();

      if (fieldName === 'fieldList') {
        if(!rule.fieldList){
          rule.fieldList=[];
        }
        this.showTextEditorDialogOption(title, label,placeholder,fieldType,isDuplicateRemoved,canAddNewAutocomplete,options,dialogWidth, 
          rule.fieldList,
          async (items: ColoredTextItem[],eventname:string) => {
          if(eventname=='save'){
            rule.fieldList = items;
          }
        });
      }
    }
  }
  async onRunTransformJoiner(): Promise<void> {
    // await this.saveConfig();
    this.onRunTransform();
  }
  async saveConfig(): Promise<void> {
    if (!this.validate()) {
      return;
    }
    const busyIndicator = this.showBusyDialog('Please wait...');
    try {
      if (this.dataTransformConfigViewModel.dataTransformerConfig?.id || this.dataTransformConfigViewModel.dataTransformerConfig?.guid) {
        await this.saveConfigImpl(this.dataTransformConfigViewModel.dataTransformerConfig.name);
      } else {
        this.showSaveConfigDialog(async (configName: string) => {
          await this.saveConfigImpl(configName);
        });
      }
      //Invoke the save current transformer cache api
      const selectedNode = this.userData.getSelectedNodeDetails();
      const activeTransformGuid = this.userData.getSelectedTransform().guid
      const userId = this.userData.getUserId()
      const orgId = this.userData.getOrgId()
      var saveCurrentTransformerCacheRequest: SaveCurrntTransfrmcacheRequest = new SaveCurrntTransfrmcacheRequest(userId, orgId, selectedNode.id, selectedNode.refineryConfigGuid, this.dataTransformConfigViewModel.selectedIngestFarmGuid, activeTransformGuid);
      await this.configService.saveCurrentTransformerCache(saveCurrentTransformerCacheRequest);
      await this.configService.getRefineryConfigByGuidAsync(this.userData.getRefineryId());
      this.getCacheStatus();
      // this.cdRef.detectChanges();
      this.snackBar.open(`Successfully saved transform pipeline '${this.userData.getSelectedTransform().name}'`, 'Dismiss', {
        duration: 5000
      });
      busyIndicator.close();
    } catch (err) {
      busyIndicator.close();
    }
  }

  async saveConfigImpl(configName: string): Promise<void> {
    
    try {
      let config = this.dataTransformConfigViewModel.dataTransformerConfig ?? new DataTransformerConfig();

      config.name = configName;
      config.organizationId = 1;
      config.dataSourceType = this.dataTransformConfigViewModel.dataSourceType;
      config.selectedIngestFarmGuid = this.dataTransformConfigViewModel.selectedIngestFarmGuid;
      
      // Save the Data Connectors
      config.dataConnectorMappings = this.dataTransformConfigViewModel.ingestConfigs
      .map ( ingestConfig =>
        new DataConnectorMapping(
          ingestConfig.id,
          ingestConfig.name,
          ingestConfig.targetDataFarm,
          ingestConfig.dataConnector.toDataConnector(),
          ingestConfig.columnMap
            .map(i => i.toColumnMapDefinition()),
          ingestConfig.guid,
          ingestConfig.masterColumnMapGuid)
      );

      //console.log('saving config...');
      //console.log(this.dataTransformConfigViewModel);

      // Save Transforms
      config.transforms = this.dataTransformConfigViewModel.transforms.map(t => t.transform);

      // Save the transform
      //const transform = config.transforms.find(t => t.id === this.viewModel.transform?.id) ?? this.viewModel.transformViewModel.transform;
      const transform = this.viewModel.transformViewModel.transform;
      //console.log(transform);

      transform.transformConfig = this.viewModel.toTransformConfig();
      // transform.dataFarmName = this.viewModel.dataFarm.name;
      // transform.dataFarmType = this.viewModel.dataFarm.dataFarmType;

      // TODO: Maintain list of transforms for this config
      const existingTransform = config.transforms.find(t => t.guid === transform.guid);
      if (existingTransform) {
        config.transforms.splice(config.transforms.indexOf(existingTransform), 1);
      }
      config.transforms.push(transform);
      

      // Save the ingest transforms
      //console.log(JSON.stringify(config));

      config = await this.configService.upsertConfig(config);
      //console.log(config);
      this.userData.setSelectedConfigJson(config);
      this.configViewModelService.setDataTransformConfigViewModel(new DataTransformConfigViewModel(config));
      this.userData.setSelectedTransform(this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid));
      //update preViewModel
      this.snapshotPreState();

      
      //const RefineryConfigJson = await this.configService.getRefineryConfigByGuidAsync(selectedNode.refineryConfigGuid);
      // //console.log('Refinery json in save = ', RefineryConfigJson) ;
      //RefineryConfigJson.nodes.filter(newNode => newNode.id == selectedNode.id)[0].data.nodeStatus = NodeRunStatus.NotRun
      //let RefineryJson = await this.configService.UpsertRefineryConfig(RefineryConfigJson);
      
      // var UpdateNodesStatus: UpdateNodesStatusRequest = new UpdateNodesStatusRequest(selectedNode.refineryConfigGuid, selectedNode.id, NodeRunStatus.PipelineModified )
      // let updateStatusreturn = await this.configService.updateUpcomingNodesStatus(UpdateNodesStatus);     

    } catch (err) {
      this.displayError(`Failed to save '${this.userData.getSelectedTransform().name}'`, 'Error', err);
    }
  }
  
  onSetDefaultRule(defaultfield:string){
    // if(defaultfield=="sourceColumn"){
    //   this.viewModel.rules.forEach(rule=>{
    //     rule.sourceColumn=this.viewModel.parameters.sourceColumn;
    //   })
    // }
    // else if(defaultfield=="targetColumn"){
    //   this.viewModel.rules.forEach(rule=>{
    //     rule.targetColumn=this.viewModel.parameters.targetColumn;
    //   })
    // }
  }
  onToggleMultiTarget(event: any){
    this.viewModel.reserialzeJids=event.checked;
  }
  onParameterFormStatusChange(status: boolean) {
    this.isParameterFormValid = status;
  }

  CalculateFieldsMapped(){
    this.viewModel.fieldMap.forEach(map=>{
      var i=0;
      map.mapTable.forEach(m=>{
        if(m.field==m.mapTo){
          i++;
        }
      });
      var joinersummery=this.joinersummary.find(j=>j.nodeID==map.nodeID);
      joinersummery.mapped=i.toString();
    });
    
    var options: string[] = [];
      this.viewModel.fieldMap.forEach(map=>{
        var maptos=map.mapTable.map(item => item.mapTo);
        maptos.forEach(map=>{
          options.push(map);
        })
      });
      // Get unique values
      var options = Array.from(new Set(options)).sort();
      this.viewModel.parameters.sourceColumns=[...options.map( i => new OptionItem(i, i))];
      this.viewModel.sourceColumns = [...options.map( i => new OptionItem(i, i))];//[...new Set<OptionItem>()];// 
      this.viewModel.sourceColumnsDT = [...options.map( i => new OptionItemDataType(i, i,''))];//to execute app-transformer-parameters
      // Get common input values
      var commonopts: string[] = [...options];
      this.viewModel.fieldMap.forEach(map=>{
        var maptos=map.mapTable.map(item => item.field);
        commonopts=commonopts.filter(opt => maptos.includes(opt));
      });
      this.viewModel.commonFields=commonopts;
      this.viewModel.fieldMap.forEach(map=>{
        this.disabledColumnsMap.set(map.nodeID, map.mapTable.map(f => f.mapTo));
      });
  }
  removeInvalidSortFields(){
    if(this.viewModel.parameters.sortInfo){
      const validSortFields = this.viewModel.parameters.sourceColumns.map(item => item.text);
      // Filter out any sortInfo where the sortField is not present in the sourceColumns' values
      this.viewModel.parameters.sortInfo = this.viewModel.parameters.sortInfo.filter(sortItem => validSortFields.includes(sortItem.sortField));
    }
  }
  removeInvalidAcrossFields(){
    var checkNoneAll=this.viewModel.fieldList.find(fl=>fl.text=="None" || fl.text=="All");
    if(!checkNoneAll){
      const validAcrossFields = this.viewModel.parameters.sourceColumns.map(item => item.text);
      this.viewModel.fieldList=this.viewModel.fieldList.filter(field => validAcrossFields.includes(field.text));
    }
    if(this.viewModel.fieldList.length==0){
      if(this.viewModel.duplicatesType===DuplicateType.exclude){
        this.viewModel.fieldList.push(new ColoredTextItem("None",NamedColorList[0]));
      }else if(this.viewModel.duplicatesType===DuplicateType.include){
        this.viewModel.fieldList.push(new ColoredTextItem("All",NamedColorList[0]));
      }
    }
  }
  disabledMapToFields:any
  disabledColumnsMap: Map<string, string[]> = new Map();
  onChangeMapTo(nodeID:string,map:JoinerMapper){
    if(map.mapTo!="Not Mapped"){
      var maps=this.viewModel.fieldMap.find(x=>x.nodeID==nodeID).mapTable.filter(f=>f.mapTo==map.mapTo);
      if (maps.length>1) {
        this.displayWarning("Duplicate value is not allowed.","Duplicate field found");
        map.mapTo = "Not Mapped";//undefined; // Reset field value
      }
    }
    this.CalculateFieldsMapped();
    //remove field from sort parameter
    this.removeInvalidSortFields(); 
    this.removeInvalidAcrossFields(); 
  }
  // Method to determine if an option should be disabled
  isOptionDisabled(nodeID:string,item: string): boolean {
    //console.log(nodeID,item)
    this.disabledMapToFields = new Set(this.viewModel.fieldMap.find(x=>x.nodeID==nodeID).mapTable.map(f => f.mapTo));
    //console.log('isOptionDisabled value: ', this.disabledMapToFields );
    return this.disabledMapToFields.has(item);
  }
  DataWriter(){
    if(this.cacheStatus=="Cached"){
      this.isDisabledDW=false;
      this.exportComponent.initializeExportComponent();
    }else{
      this.isDisabledDW=true;
      this.snackBar.open(`The Transformer is not cached`, 'Dismiss', {
        duration: 5000
      });
    }
  }

  onTabClick(event: MatTabChangeEvent): void {
    const selectedTabIndex = event.index;
    const selectedTabLabel = event.tab.textLabel;
    this.selectedTabIndx = selectedTabIndex;

    // Alert the tab index and label
   //alert(`Tab clicked: ${selectedTabLabel} (Index: ${selectedTabIndex})`);
   this.userData.setResultsTabClicked(false); 
   if(selectedTabLabel.includes("Summary")){
      // console.log("selectedTabLabel :",selectedTabLabel);
      //  if(this.source.length > 0) {
      //    let selectFilterInfoSummary = new SelectFilterInfo(this.source, this.selectFilterValues);
      //    this.onApplySelect(selectFilterInfoSummary);
      //  }
   }else{
    if(selectedTabLabel.match("Output")) {
        this.userData.setInputTabClicked(false);
        this.inputPrvwFilterViewModel.farmId = "";
        this.inputPrvwFilterViewModel.previewType = "Output";
        this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
      } else {
        this.setInputPreviewFilterViewModel()
        this.userData.setInputTabClicked(true);
      }
   }
  }  

  setJoinerResultsTabClicked(): void {
    this.userData.setResultsTabClicked(true);
  }

  setJoinerPreviewTabClicked(): void {
    this.userData.setResultsTabClicked(false);
    this.setInputPreviewFilterViewModel(); 
  }

  setInputPreviewFilterViewModel() {
    this.inputPrvwFilterViewModel.farmId = this.viewModel.fieldMap[this.selectedTabIndx].nodeID;
    this.inputPrvwFilterViewModel.previewType = "Input";
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel)
  }

  resetInputPrvwViewModel() {
    this.inputPrvwFilterViewModel.farmId = "";
    this.inputPrvwFilterViewModel.collookupFarmId = "";
    this.inputPrvwFilterViewModel.nodeType = "";
    this.inputPrvwFilterViewModel.previewType = "Joiner";
    this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = "";
  }

  get isValidateParameters(): boolean {
    return !this.isParameterFormValid;
  }
  get isValidateAdvanceSettings(): boolean {
    return this.form.invalid;
  }
  onToggleResetRows(event: any){
    this.viewModel.resetRows=event.checked;
  }
  /*changeFieldToAll(mergef: MergeOption): void {
    this.viewModel.mergeOption.forEach(merge=>{
      merge.field=mergef.field;
    });
  }*/

changeFieldToAll(mergef: MergeOption): void {

    this.viewModel.mergeOption.forEach(merge=>{
      merge.field=mergef.field;
    });
  }

 changeFieldToAllToggle(mergef: MergeOption): void {
  for (let merge of this.viewModel.mergeOption) {
    if (merge.field) {
      mergef.field = merge.field;
      break;
    }
  }

  // Set all fields to mergef.field
  //this.viewModel.mergeOption.forEach(merge => {
    //merge.field = mergef.field;
  //});
}

  onToggleRemoveDuplicateRows(event: any){
    this.viewModel.runDedup=event.checked;
  }
  onChangeType(duplicatesType:DuplicateType){
    if(duplicatesType===DuplicateType.exclude){
      var flist=this.viewModel.fieldList.find(fl=>fl.text=="All");
      if(flist){
        this.viewModel.fieldList=[];
        this.viewModel.fieldList.push(new ColoredTextItem("None",NamedColorList[0]));
      }
    }else if(duplicatesType===DuplicateType.include){
      var flist=this.viewModel.fieldList.find(fl=>fl.text=="None");
      if(flist){
        this.viewModel.fieldList=[];
        this.viewModel.fieldList.push(new ColoredTextItem("All",NamedColorList[0]));
      }
    }
  }
  async setDefaultValues(transformType:TransformType): Promise<void>{
    const selectedNode=this.userData.getSelectedNodeDetails();
    const masterconfig=this.userData.getMasterTransformers().find(x=>x.id==transformType);
    var parameters=masterconfig.parameters.find(x=>x.farmtypeid==selectedNode.farmtypeid);
    if(parameters){
      var params=parameters.parameters;
      this.resetRows=params.find(x=>x.jsonobject=='resetRows');
      this.runDedup=params.find(x=>x.jsonobject=='runDedup');
      this.mergeOption=params.find(x=>x.jsonobject=='mergeOption');
      //other parameters
      //advanced settings parameters
      //check this is first this.viewModel.sampleEnd =0
      if((this.viewModel.sampleEnd-1)==0 || isNaN(this.viewModel.sampleEnd)){
          if(this.resetRows.default!=""){
            this.viewModel.resetRows=this.stringToBoolean(this.resetRows.default);
          }
          if(this.runDedup.default!=""){
            this.viewModel.runDedup=this.stringToBoolean(this.runDedup.default);
          }
      }
    }else{
      //advanced settings parameters
      // this.bufferRows.label="Buffer Rows";this.bufferRows.jsonobject="bufferRows";this.bufferRows.min=0;this.bufferRows.max=10000000;
      // this.threads.label="Threads (0 > Auto)";this.threads.jsonobject="threads";this.threads.min=0;this.threads.max=64;
      // this.resetRows.label="Reset Row Numbers";this.resetRows.jsonobject="resetRows";
    }
  }
  async removeInvalidValues(): Promise<void>{
    //other parameters
    //advanced settings parameters
  }
  async loadImportTransformer(transform: any): Promise<void>{
    const busyIndicator = this.showBusyDialog('Please wait...');
    try{
      if(this.userData.getSelectedNodeDetails().farmtypeid!=transform.farmType){
        this.displayError("Current DataFarmType is " + DataFarmTypeUtil.toString(this.userData.getSelectedNodeDetails().farmtypeid) + ". But you are trying to load a different DataFarmType: " + DataFarmTypeUtil.toString(transform.farmType),"Error");
        return;
      }else if(this.transformType!=transform.transformType){
        this.displayError("Current transform is " + TransformTypeUtil.toString(this.transformType) + ". But you are trying to load a different transform type: " + TransformTypeUtil.toString(transform.transformType),"Error");
        return;
      }
      var ctranformconfig=this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid);
      ctranformconfig.transform.transformConfig=transform;
      var newmodel =new JoinerViewModel(this.dataDictService,this.configService,this.dataTransformConfigViewModel,ctranformconfig);
      // force new object reference for UI refresh
      // this.viewModel.rules=[];
      // this.viewModel.rules=[...newmodel.rules];
      // this.isRuleSetEmpty = this.viewModel.rules.length === 0;
      // this.dataSource.data = this.viewModel.rules;
      // //update rule table height
      // if(this.viewModel.rules.length<=10){
      //   this.minrowcount=this.viewModel.rules.length;
      // }else{
      //   this.minrowcount=10;
      // }
      // this.maxrowcount=this.viewModel.rules.length;
    }catch (err) {
      this.displayError(`Failed to save import transformer`, 'Error', err);
    }finally {
      busyIndicator.close();
    }
  }

  onTargetColumnChanged(nodeID: string, value: any, _event: any): void {
    this.onChangeMapTo(nodeID, value);
  }
  handleMoveToField(direction: 'forward' | 'reverse', index: number) {
    if (direction  === 'reverse') {
      this.focusPreviousInput(index);
    } else {
      this.focusNextInput(index);
    }
  }
  focusNextInput(index: number) {
    const nextElement = document.querySelectorAll('app-autocomplete-field input')[index + 1];
    if (nextElement) {
      (nextElement as HTMLElement).focus();
    }
  }
  focusPreviousInput(index: number) {
    const previousElement = document.querySelectorAll('app-autocomplete-field input')[index - 1];
    if (previousElement) {
      (previousElement as HTMLElement).focus();
    }
  }

  async onShowFilter(sender: PreviewTableComponent, columnName: string): Promise<void> {
    const inputTables = this.joinerNodePreviewTables?.toArray() ?? [];
    const inputIndex = inputTables.indexOf(sender);
    if (inputIndex >= 0 && inputIndex < this.joinerInputPreviewTypes.length) {
      const needsFetch = !sender.activeFilterSet || sender.activeFilterSet.length === 0
        || !sender.filteredColumnVals || sender.filteredColumnVals.length === 0;
      if (needsFetch) {
        const busyIndicator = this.showBusyDialog('Please wait...');
        try {
          const cachekeyRequest = await this.GetCacheKeyRequest(this.joinerInputPreviewTypes[inputIndex]);
          const request = new GetFilteredselcolvalsRequest(
            cachekeyRequest.userId, cachekeyRequest.orgId, cachekeyRequest.refineryId,
            cachekeyRequest.nodeId, cachekeyRequest.transformId, cachekeyRequest.cacheKeyType,
            columnName);
          await sender.fetchselectedcolsvalsfrmAPI(request);
        } catch (ex) {
          this.displayError('Failed to fetch filter values. Please try again later.', 'Failed to fetch');
        } finally {
          busyIndicator.close();
        }
      } else {
        sender.applyStackFilters(columnName);
      }
      return;
    }
    const summaryTables = this.joinerSummaryPreviewTables?.toArray() ?? [];
    const summaryIndex = summaryTables.indexOf(sender);
    if (summaryIndex >= 0 && summaryIndex < this.joinerInputPreviewTypes.length) {
      const needsFetch = !sender.activeFilterSet || sender.activeFilterSet.length === 0
        || !sender.filteredColumnVals || sender.filteredColumnVals.length === 0;
      if (needsFetch) {
        const busyIndicator = this.showBusyDialog('Please wait...');
        try {
          const cachekeyRequest = await this.GetCacheKeyRequest(this.joinerInputPreviewTypes[summaryIndex]);
          const request = new GetFilteredselcolvalsRequest(
            cachekeyRequest.userId, cachekeyRequest.orgId, cachekeyRequest.refineryId,
            cachekeyRequest.nodeId, cachekeyRequest.transformId, cachekeyRequest.cacheKeyType,
            columnName);
          await sender.fetchselectedcolsvalsfrmAPI(request);
        } catch (ex) {
          this.displayError('Failed to fetch filter values. Please try again later.', 'Failed to fetch');
        } finally {
          busyIndicator.close();
        }
      } else {
        sender.applyStackFilters(columnName);
      }
      return;
    }
    await super.onShowFilter(sender, columnName);
  }

  override async LoadSummaryPersistance(sender: PreviewTableComponent, isNewCache: boolean = false): Promise<void> {
    const tables = this.joinerSummaryPreviewTables?.toArray() ?? [];
    const index = tables.indexOf(sender);
    if (index >= 0 && index < this.joinerPreviewTabs.length) {
      const tab = this.joinerPreviewTabs[index];
      const key = await this.GetLocalStorageKey(tab.typeName);
      if (this.userData.getSelectValues(key)) {
        this.joinerSelectValues[index] = this.userData.getSelectValues(key) ?? [];
        this.joinerSelectEmptyColumns[index] = this.userData.getSelectEmptyColumns(key) ?? [];
        this.joinerSelectFilterValues[index] = this.userData.getSelectFilterValues(key) ?? [];
        const summaryFilter = this.userData.getSummaryFilter(key);
        const summarySort = this.userData.getSummarySort(key);
        if (summaryFilter?.length) {
          sender.activeFilterSet = summaryFilter;
          sender.activeColumnFilters = summaryFilter.map((x: any) => x.columnName);
        }
        if (summarySort?.length) {
          sender.activeSortsSet = summarySort;
        }
        this.selectFilterValues = this.joinerSelectFilterValues[index];
        await this.refreshSummaryDataFarmPreviewAsync(sender, isNewCache);
      }
    } else {
      await super.LoadSummaryPersistance(sender, isNewCache);
    }
  }

  override async refreshSummaryDataFarmPreviewAsync(sender: PreviewTableComponent, isNewCache: boolean = false): Promise<void> {
    const tables = this.joinerSummaryPreviewTables?.toArray() ?? [];
    const index = tables.indexOf(sender);
    if (index < 0 || index >= this.joinerPreviewTabs.length) {
      await super.refreshSummaryDataFarmPreviewAsync(sender, isNewCache);
      return;
    }
    const filterValues = this.joinerSelectFilterValues[index] ?? [];
    if (filterValues.length === 0) return;
    const busyIndicator = this.showBusyDialog('Loading Data Preview Summary.');
    try {
      const filters = (sender.activeFilterSet ?? []).map(f => {
        const filterInfo = new ColumnFilter();
        filterInfo.field = f.columnName;
        filterInfo.values = f.values;
        return filterInfo;
      });
      const options = new PreviewDataOptions(sender.pageIndex, sender.rowsPerPage);
      options.filters = filters;
      options.sortInfo = sender.activeSortsSet ?? [];
      this.joinerSummaryRows[index] = '';
      const cachekeyRequest = await this.GetCacheKeyRequest(this.joinerInputPreviewTypes[index]);
      const inputTable = this.joinerNodePreviewTables?.toArray()[index];
      const parentFilters = (inputTable?.activeFilterSet ?? []).map(f => {
        const filterInfo = new ColumnFilter();
        filterInfo.field = f.columnName;
        filterInfo.values = f.values;
        return filterInfo;
      });
      const request = new GetSummaryDataFarmPreviewRequest(
        cachekeyRequest.userId, cachekeyRequest.orgId, cachekeyRequest.refineryId,
        cachekeyRequest.nodeId, cachekeyRequest.transformId, cachekeyRequest.cacheKeyType,
        options, filterValues.join(',') ?? '', isNewCache, SummaryType.DataFarm, parentFilters);
      const response = await this.configService.getSummaryDataFarm(request);
      if (response.data.totalRows > 0) {
        const totalRows = Number(response.data.totalSummaryFarmRows).toLocaleString();
        this.joinerSummaryRows[index] = `Total Row Count: ${totalRows}`;
        const countColumns = response.data.columns.filter((col: any) => col.columnName.includes('count'));
        const rowdata = Object.values(response.data.rows) as any[];
        rowdata.forEach(row => {
          countColumns.forEach((col: any) => {
            const colIndex = col.index.toString();
            if (row[colIndex] === 0) row[colIndex] = '';
          });
        });
        sender.bindData(response.data, 'No Summary preview data');
      }
    } catch (err) {
      this.displayError('Failed to get data farm preview', 'Error', err);
    } finally {
      sender.isGettingData.next(false);
      busyIndicator.close();
    }
  }

  async showJoinerSummarySelectFilter(menuTrigger: MatMenuTrigger, index: number): Promise<void> {
    this.activeJoinerSummaryIndex = index;
    this.menuTrigger = menuTrigger;
    this.selectFilterValues = [...new Set(this.joinerSelectFilterValues[index] ?? [])];
    await this.bindJoinerSummary(index);
    menuTrigger.openMenu();
  }

  private async bindJoinerSummary(index: number): Promise<void> {
    this.selectFilterValues = [...new Set(this.joinerSelectFilterValues[index] ?? [])];
    if (!this.joinerSelectValues[index] || this.joinerSelectValues[index].length === 0) {
      await this.bindJoinerSelectValues(index);
    }
    this.selectValues = [...new Set(this.joinerSelectValues[index] ?? [])];
    this.selectEmptyColumns = [...new Set(this.joinerSelectEmptyColumns[index] ?? [])];
  }

  private async bindJoinerSelectValues(index: number): Promise<void> {
    const inputTable = this.joinerNodePreviewTables?.toArray()[index];
    if (!inputTable?.displayedColumnInfos) return;
    const tab = this.joinerPreviewTabs[index];
    this.joinerSelectValues[index] = [...inputTable.displayedColumnInfos.map((c: any) => c.name).filter((n: string) => n !== 'row')];
    this.userData.setSelectValues(await this.GetLocalStorageKey(tab.typeName), this.joinerSelectValues[index]);
    const cachekeyRequest = await this.GetCacheKeyRequest(this.joinerInputPreviewTypes[index]);
    const request = new GetSummaryDataFarmPreviewRequest(
      cachekeyRequest.userId, cachekeyRequest.orgId, cachekeyRequest.refineryId,
      cachekeyRequest.nodeId, cachekeyRequest.transformId, cachekeyRequest.cacheKeyType,
      null, this.selectFilterValues.join(',') ?? '');
    const response = await this.configService.getSummaryEmptyColslist(request);
    this.joinerSelectEmptyColumns[index] = response.blanks_cols_list;
    this.userData.setSelectEmptyColumns(await this.GetLocalStorageKey(tab.typeName), this.joinerSelectEmptyColumns[index]);
  }

  async onApplySelectJoiner(info: SelectFilterInfo): Promise<void> {
    const index = this.activeJoinerSummaryIndex;
    if (index < 0) return;
    this.selectFilterValues = info.values.filter(cl => cl != null).map(col => col);
    this.menuTrigger.closeMenu();
    this.joinerSelectFilterValues[index] = [...this.selectFilterValues];
    const tab = this.joinerPreviewTabs[index];
    this.userData.setSelectFilterValues(await this.GetLocalStorageKey(tab.typeName), this.joinerSelectFilterValues[index]);
    const table = this.joinerSummaryPreviewTables?.toArray()[index];
    if (table) {
      await this.clearAllSortFilterCache(table, true);
    }
  }

  onClearSelectJoiner(_colName: string): void {
    this.menuTrigger.closeMenu();
  }

  onCloseSelectJoiner(): void {
    this.menuTrigger.closeMenu();
  }

  async onChangeSourceJoiner(sourcetype: string): Promise<void> {
    const index = this.joinerPreviewTabs.findIndex(t => t.typeName === sourcetype);
    if (index >= 0) {
      this.activeJoinerSummaryIndex = index;
      await this.bindJoinerSummary(index);
    }
  }
}